import React from "react";

import { TextField } from "@mui/material";
import { useTranslation } from "react-i18next";

import { EntityErrors } from "@/components/alerts/add-v2/model/entityRules";
import { ItemEntity } from "@/components/alerts/add-v2/model/types";

import { ENTITY_FULL_ROW_SX } from "./entityFieldLayout";

/**
 * Item / Other — the catch-all, and the bucket every legacy tag was migrated into. Its name is the
 * only required field, because without it the card has nothing to show.
 *
 * The error is `validateEntityDraft`'s, handed down through the editor.
 */

interface ItemFieldsProps {
  value: ItemEntity;
  errors: EntityErrors;
  onPatch: (next: Partial<ItemEntity>) => void;
}

export const ItemFields: React.FC<ItemFieldsProps> = ({
  value,
  errors,
  onPatch,
}) => {
  const { t } = useTranslation("bulletin/create-v2");

  return (
    <>
      <TextField
        size="small"
        fullWidth
        required
        error={!!errors.itemName}
        helperText={
          errors.itemName
            ? t(`validation.entity_${errors.itemName}`)
            : undefined
        }
        label={t("entities.item_name")}
        placeholder={t("entities.item_name_placeholder")}
        value={value.itemName}
        onChange={(event) => onPatch({ itemName: event.target.value })}
      />

      <TextField
        size="small"
        fullWidth
        multiline
        minRows={3}
        sx={ENTITY_FULL_ROW_SX}
        label={t("entities.additional_description")}
        value={value.additionalDescription}
        onChange={(event) =>
          onPatch({ additionalDescription: event.target.value })
        }
      />
    </>
  );
};
